// Change this value for each release and set frontend.version.required-version to match.
// Bundled with the page: never replace it with a value fetched from the server.
export const APP_VERSION = '2026.10.21.1'
